import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { ISchedule } from '@cbridge-packages/schedule';
import { scheduleIntervalStoreSelector } from '../scheduleInterval.selector';

export const scheduleIntervalListSelector = createCachedSelector(
  [
    path(scheduleIntervalStoreSelector).data(),
    prop<{ scheduleId: ISchedule['scheduleId'] }>().scheduleId(),
  ],
  (data, scheduleId) => {
    return data[scheduleId] ?? [];
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ scheduleId: ISchedule['scheduleId'] }>().scheduleId(),
});
